import Vue from "vue";
import VueRouter from "vue-router";
import LoginView from "../components/LoginView.vue";
import HomeView from "../views/HomeView.vue";
// import { component } from "vue/types/umd";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: LoginView,
  },
  //   {
  // path: "/about",
  // name: "about",
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  // component: () =>
  //   import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  //   },
  {
    path: "/home",
    name: "home",
    // component:() =>{"../views/HomeView.vue"},
    component: HomeView,
  },
  {
    path: "/homes",
    name: "homes",
    // component:() =>{"../views/HomeView.vue"},
    component: () => import("../views/Homes.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
